import L from 'leaflet';
import * as turf from '@turf/turf';

export const getLayerPane = (layerKey, feature) => {
  if (feature && feature.geometry && feature.geometry.type === 'Point') {
    return 'pointPane';
  }

  if (
    feature &&
    feature.geometry &&
    feature.geometry.type === 'MultiLineString'
  ) {
    return 'linePane';
  }

  if (layerKey === 'CRD_Municipal_Boundaries_v1') {
    return 'polygonPane';
  }

  return 'polygonPane2';
};

export const calculateLabelSize = (area, zoom) => {
  const baseFontSize = 10;

  if (area >= 10) {
    return baseFontSize;
  } else if (area >= 1.5) {
    return zoom >= 10 ? baseFontSize : 0;
  } else if (area >= 1) {
    return zoom >= 11 ? baseFontSize : 0;
  } else if (area >= 0.5) {
    return zoom >= 11.5 ? baseFontSize : 0;
  } else if (area >= 0.25) {
    return zoom >= 11.75 ? baseFontSize : 0;
  } else if (area >= 0.1) {
    return zoom >= 12 ? baseFontSize : 0;
  } else if (area >= 0.025) {
    return zoom >= 13 ? baseFontSize : 0;
  } else {
    return zoom >= 14 ? baseFontSize : 0;
  }
};

export const fitToFeature = (layer, map, isSidebarOpen) => {
  try {
    const paddingTopLeft = [10, 50];
    const paddingBottomRight = isSidebarOpen ? [100, 25] : [20, 50];

    let bounds;

    if (typeof layer.getBounds === 'function') {
      bounds = layer.getBounds();
    }
    else if (typeof layer.getLatLng === 'function') {
      const latlng = layer.getLatLng();
      const offset = 0.01;
      bounds = L.latLngBounds(
        [latlng.lat - offset, latlng.lng - offset],
        [latlng.lat + offset, latlng.lng + offset]
      );
    }

    if (bounds && bounds.isValid()) {
      map.fitBounds(bounds, {
        paddingTopLeft,
        paddingBottomRight,
        maxZoom: 18,
        animate: true,
        duration: 0.5,
      });
    }
  } catch (error) {
    console.error('Error fitting to feature:', error);
  }
};

export const fitBoundsToLayers = (map, layerGroups, isSidebarOpen, onComplete) => {
  const paddingTopLeft = [10, 50];
  const paddingBottomRight = isSidebarOpen ? [450, 25] : [20, 50]; // ✅ More padding for sidebar

  // Convert Map to array of values, or Object.values for plain objects
  const layerArray = layerGroups instanceof Map
    ? Array.from(layerGroups.values())
    : Object.values(layerGroups);

  if (layerArray.length === 0) {
    console.warn('⚠️ No layers to fit bounds to');
    if (onComplete) onComplete();
    return;
  }

  setTimeout(() => {
    try {
      const validGroups = [];

      layerArray.forEach((group) => {
        if (group && typeof group.getBounds === 'function') {
          try {
            const bounds = group.getBounds();
            if (bounds && bounds.isValid && bounds.isValid()) {
              validGroups.push(group);
            }
          } catch (boundsError) {
            console.warn('⚠️ Error getting bounds for group:', boundsError);
          }
        }
      });

      if (validGroups.length > 0) {
        // Combine all valid groups into one FeatureGroup for bounds calculation
        const combinedGroup = L.featureGroup(validGroups);
        const combinedBounds = combinedGroup.getBounds();

        if (combinedBounds && combinedBounds.isValid()) {
          map.fitBounds(combinedBounds, {
            paddingTopLeft,
            paddingBottomRight,
            maxZoom: 15, // ✅ Don't zoom too close for selection context
            animate: true,
            duration: 0.5,
          });
          console.log('✅ Fitted bounds to', validGroups.length, 'layers');
        }
      } else {
        console.warn('⚠️ No valid bounds found in layers');
      }

      if (onComplete) {
        onComplete();
      }
    } catch (error) {
      console.error('❌ Error fitting bounds:', error);
      if (onComplete) {
        onComplete();
      }
    }
  }, 100); // Delay to ensure layers are fully rendered
};